/* eslint-disable no-unused-vars */
import { GraphQlApi as api } from '../../api/index'
import { auth } from '../../index'

export default {
  namespaced: true,
  namespace: 'processes',
  state: () => ({
    needReRender: false,
    formCode: undefined
  }),
  mutations: {},
  actions: {
    async getBusinessProcesses({ commit }) {
      return await api.getBusinessProcessesAsync()
    },

    async getFormDefinition({ commit }, id) {
      return await api.getFormDefinitionAsync(id)
    },

    async startProcess({ commit }, data) {
      const processData = JSON.stringify(data)
      return await api.startProcessAsync(processData)
    },

    async getForms ({ commit }, onlySystem) {
      return await api.getForms(onlySystem)
    },

    getUserId({ commit }) {
      return auth.getUserData().id
    }
  }
}